import { CommodityType, Severity } from '@ui/aos-lib';

export enum EventConfigurationActivityType {
  Alarm = 'Alarm',
  Metric = 'Metric',
  Reading = 'Reading'
}

export enum EventConfigurationDeviceType {
  All = 'All',
  BaseStation = 'BaseStation',
  DCU = 'DCU',
  ExactaGuardGateway = 'ExactaGuardGateway',
  MTU = 'MTU',
  Meter = 'Meter',
  RMDSensor = 'RMDSensor',
  Unknown = 'Unknown'
}

export type EventConfigurationSeverity = Severity.Critical | Severity.Notice | Severity.Severe | Severity.Warning;

export interface EventConfigurationSeverityRule {
  readonly severityLevel: EventConfigurationSeverity;
  readonly threshold: number;
}

interface EventConfigurationAPITrigger {
  readonly activityType: EventConfigurationActivityType;
  readonly operator: '<' | '>' | null;
}

export interface EventConfigurationAPIItem {
  readonly commodity: CommodityType;
  readonly description: string;
  readonly deviceType: EventConfigurationDeviceType;
  readonly deviceTypeName: string; // TODO: Should we use an enum with 'All', 'Base Station', 'Sensor'…?
  readonly eventGroup: string;
  readonly eventTypeId: number;
  readonly isEnabled: boolean;
  readonly lastUpdateTimestamp: string;
  readonly multiplier: string;
  readonly name: string;
  readonly severityOperator: '<' | '>' | null;
  readonly severityRules: readonly EventConfigurationSeverityRule[];
  readonly trigger: EventConfigurationAPITrigger;
  readonly unitOfMeasure: string;
  readonly updatedBy: string;
}

export interface EventConfigurationOverrideAPIBody {
  eventTypeId: number;
  severityRules: Array<EventConfigurationSeverityRule>;
  description: string;
  isEnabled: boolean;
}

export interface EventConfigurationResponse {
  readonly items: readonly EventConfigurationAPIItem[];
  readonly totalCount: number;
}

export interface EventGroupsResponse {
  groupName: string;
}

export interface EventGroupsWithEventNamesResponse {
  groupName: string;
  eventNames: string[];
}
